export default __webpack_public_path__ + "static/media/nearExampleImg2.accaa888.jpg";